document.querySelectorAll('.scroll-mobile').forEach(block => {
  const tableContainer = block.querySelector('.table-container');
  const tableWrapper = block.querySelector('.table-wrapper');
  const setTableScroll = () => {
    const width = block.querySelector('table').offsetWidth - tableWrapper.offsetWidth;
    const scrollPercent = width > 0 ? (100 * tableWrapper.scrollLeft) / width : 0;
    const left = scrollPercent < 2 ? 0 : 1;
    const right = scrollPercent > 98 || width <= 0 ? 0 : 1;
    tableContainer.style.setProperty('--left-opacity', left);
    tableContainer.style.setProperty('--right-opacity', right);
  };

  tableWrapper.addEventListener('scroll', setTableScroll);
  window.addEventListener('resize', setTableScroll);
  document.addEventListener('DOMContentLoaded', setTableScroll);
  window.addEventListener('customLoaded', setTableScroll);
});

document.querySelectorAll('[class*="col-as-head"]').forEach(block => {
  let colAsHeadBP;
  block.classList.forEach(classValue => {
    if (classValue.includes('col-as-head')) {
      colAsHeadBP = parseInt(classValue.replace('col-as-head=', ''), 10);
    }
  });

  const tables = block.querySelectorAll('table');
  tables.forEach(table => {
    const tableHead = table.querySelector('thead');
    let firstHeadCell;
    if (tableHead) {
      firstHeadCell = tableHead.querySelector('tr').querySelector('th');
    }
    const firstHeadCellText = firstHeadCell ? firstHeadCell.innerHTML : '';
    const tableRows = table.querySelector('tbody').querySelectorAll('tr');
    const oddRowStyles = window.getComputedStyle(tableRows[0]);
    const oddRowsBGcolor = oddRowStyles.getPropertyValue('background-color');
    const oddRowsColor = oddRowStyles.getPropertyValue('color');
    const evenRowStyles = window.getComputedStyle(tableRows[1]);
    const evenRowsBGcolor = evenRowStyles.getPropertyValue('background-color');
    const evenRowsColor = evenRowStyles.getPropertyValue('color');

    const switchCells = () => {
      tableRows.forEach(tableRow => {
        const cells = tableRow.querySelectorAll('td');
        cells.forEach((cell, i) => {
          if (window.innerWidth <= colAsHeadBP) {
            if (i > 0) {
              cell.style.backgroundColor = evenRowsBGcolor;
              cell.style.color = evenRowsColor;
            } else {
              cell.style.backgroundColor = oddRowsBGcolor;
              cell.style.color = oddRowsColor;
            }
          } else {
            cell.style.removeProperty('background-color');
            cell.style.removeProperty('color');
          }
        });
      });
      if (tableHead) {
        firstHeadCell.innerHTML = window.innerWidth <= colAsHeadBP ? '' : firstHeadCellText;
      }
    };
    window.addEventListener('resize', switchCells);
    document.addEventListener('DOMContentLoaded', switchCells);
    window.addEventListener('customLoaded', switchCells);
  });
});
